import React from 'react';
import { View } from 'react-native';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
import Text from 'design-system/Text';
import { CardView, QRCode, rem, Spacer } from 'design-system';
import Modal from './Modal';
const logo = require('../../features/pay/img/bear@3x.png');
const UnavailableOnWebModalContent = ({ appLink }) => {
    const styles = useStyles(styleSet);
    return (<View>
      <Text TextThin-14 Secondary>
        This functionality is not available on the web version. Scan the QR code
        to open the Emma mobile app.
      </Text>
      <Spacer h={24}/>
      <CardView noMargin style={styles.qrContainer}>
        <QRCode value={appLink} ecl="quartile" logo={logo}/>
      </CardView>
    </View>);
};
export const UnavailableOnWebModal = {
    show: (appLink, title) => {
        Modal.show(<UnavailableOnWebModalContent appLink={appLink}/>, {
            title,
        });
    },
    hide: Modal.hide,
};
const styleSet = createStyleSheets((colors) => ({
    qrContainer: {
        paddingVertical: rem(24),
        alignItems: 'center',
        backgroundColor: colors.borders.divider,
    },
}));
